import { STATE_KEYS } from './state';
import { $mutate } from './helpers';

const MUTATION_TYPES = {
  SET_APPS: 'setApps',
  SET_GROUPS: 'setGroups',
  SET_DISABLED_APPS: 'setDisabledApps',
  SET_ACTIVE_ROUTE: 'setActiveRoute',
  SET_ACTIVE_ROUTE_PARAMS: 'setActiveRouteParams',
  SET_IFRAME_STATE: 'setIframeState',
  SET_LD_FLAGS: 'setLDFlags',
  SET_LOCALE: 'setLocale',
};

export function setActiveRoute(routeName) {
  $mutate(null, MUTATION_TYPES.SET_ACTIVE_ROUTE, routeName);
}

export function setRouteParams(params) {
  $mutate(null, MUTATION_TYPES.SET_ACTIVE_ROUTE_PARAMS, params);
}

export function setIframeState(namespace, loaded) {
  $mutate(null, MUTATION_TYPES.SET_IFRAME_STATE, { namespace, loaded });
}

// we will changed the way this works from array to map
/* eslint-disable no-param-reassign */
const mutations = {
  [MUTATION_TYPES.SET_APPS](state, apps = {}) {
    state[STATE_KEYS.APPS] = apps;
  },
  [MUTATION_TYPES.SET_GROUPS](state, groups = {}) {
    state[STATE_KEYS.GROUPS] = groups;
  },
  [MUTATION_TYPES.SET_DISABLED_APPS](state, disabledApps = false) {
    state[STATE_KEYS.DISABLED_APPS] = disabledApps;
  },
  [MUTATION_TYPES.SET_ACTIVE_ROUTE](state, routeName) {
    state[STATE_KEYS.ACTIVE_ROUTE] = routeName;
  },
  [MUTATION_TYPES.SET_ACTIVE_ROUTE_PARAMS](state, params) {
    state[STATE_KEYS.ACTIVE_ROUTE_PARAMS] = params || null;
  },
  [MUTATION_TYPES.SET_IFRAME_STATE](state, { namespace, loaded }) {
    state[STATE_KEYS.IFRAME_STATES] = {
      ...state[STATE_KEYS.IFRAME_STATES],
      [namespace]: loaded,
    };
  },
  [MUTATION_TYPES.SET_LD_FLAGS](state, flags) {
    state[STATE_KEYS.LD_FLAGS] = flags;
  },
  [MUTATION_TYPES.SET_LOCALE](state, locale) {
    state[STATE_KEYS.LOCALE] = locale;
  },
};

export {
  mutations,
  MUTATION_TYPES,
};
